(function () {
  if (window.cfCartQuantityErrors) return;
  const configNode = document.getElementById('cf-cart-quantity-messages');
  if (!configNode) return;
  const messages = JSON.parse(configNode.textContent);
  window.cfCartQuantityErrors = true;
  function isCartQuantity(input) {
    return input instanceof HTMLInputElement && input.matches('.quantity__input') &&
      input.form && ['cart', 'CartDrawer-Form'].includes(input.form.id);
  }
  function messageFor(input) {
    const validity = input.validity;
    if (validity.rangeOverflow) {
      const text = input.hasAttribute('data-cone-weight') ? messages.cones : messages.maximum;
      return text.replace('[maximum]', input.max);
    }
    if (validity.rangeUnderflow) return messages.minimum.replace('[minimum]', input.min);
    return messages.invalid;
  }
  function errorContainer(input) {
    const item = input.closest('.cart-item');
    if (!item) return null;
    return item.querySelector('.cart-item__error');
  }
  function showError(input) {
    const container = errorContainer(input);
    if (!container) return;
    const text = container.querySelector('.cart-item__error-text') || container;
    text.textContent = messageFor(input);
    container.classList.add('cf-quantity-error');
    container.dataset.cfQuantityError = 'true';
    container.setAttribute('role', 'alert');
    container.hidden = false;
    input.setAttribute('aria-invalid', 'true');
    if (container.id) {
      const ids = new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
      ids.add(container.id);
      input.setAttribute('aria-describedby', Array.from(ids).join(' '));
    }
  }
  function clearError(input) {
    const container = errorContainer(input);
    if (!container || container.dataset.cfQuantityError !== 'true') return;
    const text = container.querySelector('.cart-item__error-text') || container;
    text.textContent = '';
    container.classList.remove('cf-quantity-error');
    delete container.dataset.cfQuantityError;
    input.removeAttribute('aria-invalid');
    const ids = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter(id => id && id !== container.id);
    if (ids.length) input.setAttribute('aria-describedby', ids.join(' '));
    else input.removeAttribute('aria-describedby');
  }
  document.addEventListener('invalid', function (event) {
    const input = event.target;
    if (!isCartQuantity(input)) return;
    event.preventDefault();
    showError(input);
    const first = Array.from(input.form.elements).find(element => isCartQuantity(element) && !element.validity.valid);
    if (first !== input) return;
    requestAnimationFrame(function () {
      if (!input.isConnected || input.validity.valid) return;
      input.focus({ preventScroll: true });
      input.scrollIntoView({ block: 'center', behavior: 'auto' });
    });
  }, true);
  document.addEventListener('change', function (event) {
    const input = event.target;
    if (!isCartQuantity(input)) return;
    if (!input.validity.valid) {
      event.stopImmediatePropagation();
      showError(input);
    } else {
      clearError(input);
    }
  }, true);
  document.addEventListener('input', function (event) {
    const input = event.target;
    if (!isCartQuantity(input) || input.getAttribute('aria-invalid') !== 'true') return;
    if (input.validity.valid) clearError(input);
    else showError(input);
  }, true);
})();
